const baseAnchorData = { anchor: "" };
const AnchorData = {
  fromJSON(object) {
    const message = { ...baseAnchorData };
    message.anchor = object.anchor !== void 0 && object.anchor !== null ? String(object.anchor) : "";
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.anchor !== void 0 && (obj.anchor = message.anchor);
    return obj;
  }
};
export {
  AnchorData
};
//# sourceMappingURL=decoration_anchor.js.map
